function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2.13379C7.1776 2.13379 0 7.39733 0 13.8671C0 17.5583 2.37708 21.0372 6.38229 23.2468L4.29714 29.1562C4.22344 29.3645 4.28594 29.5968 4.45417 29.74C4.6224 29.8833 4.86146 29.908 5.05547 29.802L13.1089 25.4085C14.0672 25.5361 15.0331 25.6002 16 25.6005C24.8224 25.6005 32 20.3369 32 13.8671C32 7.39733 24.8224 2.13379 16 2.13379V2.13379ZM16 24.5338C15.0245 24.5335 14.0503 24.4648 13.0844 24.3278C12.9706 24.3119 12.8549 24.3327 12.7542 24.3877L5.76745 28.1994L7.54245 23.17C7.63125 22.9189 7.52109 22.6406 7.28438 22.5184C3.39036 20.5104 1.06667 17.2762 1.06667 13.8671C1.06667 7.98561 7.76589 3.20046 16 3.20046C24.2341 3.20046 30.9333 7.98561 30.9333 13.8671C30.9333 19.7486 24.2341 24.5338 16 24.5338Z",
  fill: "url(#paint740_linear_1316:35)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 10.1338H9.06667V11.2005H8V10.1338Z",
  fill: "url(#paint741_linear_1316:35)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1333 10.1338H11.2V11.2005H10.1333V10.1338Z",
  fill: "url(#paint742_linear_1316:35)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2666 10.1338H23.9999V11.2005H12.2666V10.1338Z",
  fill: "url(#paint743_linear_1316:35)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8 12.2666H15.4667V13.3333H8V12.2666Z",
  fill: "url(#paint744_linear_1316:35)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5334 12.2666H17.6001V13.3333H16.5334V12.2666Z",
  fill: "url(#paint745_linear_1316:35)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6667 12.2666H24.0001V13.3333H18.6667V12.2666Z",
  fill: "url(#paint746_linear_1316:35)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14.4004H24V15.4671H8V14.4004Z",
  fill: "url(#paint747_linear_1316:35)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16.5332H12.2667V17.5999H8V16.5332Z",
  fill: "url(#paint748_linear_1316:35)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3333 16.5332H14.3999V17.5999H13.3333V16.5332Z",
  fill: "url(#paint749_linear_1316:35)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4666 16.5332H16.5332V17.5999H15.4666V16.5332Z",
  fill: "url(#paint750_linear_1316:35)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6001 16.5332H24.0001V17.5999H17.6001V16.5332Z",
  fill: "url(#paint751_linear_1316:35)"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint740_linear_1316:35",
  x1: 0.867839,
  y1: 33.5159,
  x2: 28.1166,
  y2: -0.56787,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint741_linear_1316:35",
  x1: 8.02893,
  y1: 11.3408,
  x2: 9.09982,
  y2: 10.1799,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint742_linear_1316:35",
  x1: 10.1622,
  y1: 11.3408,
  x2: 11.2331,
  y2: 10.1799,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint743_linear_1316:35",
  x1: 12.5848,
  y1: 11.3408,
  x2: 12.7637,
  y2: 9.20703,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint744_linear_1316:35",
  x1: 8.2025,
  y1: 13.4736,
  x2: 8.48082,
  y2: 11.3615,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint745_linear_1316:35",
  x1: 16.5624,
  y1: 13.4736,
  x2: 17.6333,
  y2: 12.3127,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint746_linear_1316:35",
  x1: 18.8114,
  y1: 13.4736,
  x2: 19.1948,
  y2: 11.3956,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint747_linear_1316:35",
  x1: 8.43392,
  y1: 15.6074,
  x2: 8.56556,
  y2: 13.4667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint748_linear_1316:35",
  x1: 8.11571,
  y1: 17.7402,
  x2: 8.58622,
  y2: 15.6999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint749_linear_1316:35",
  x1: 13.3622,
  y1: 17.7402,
  x2: 14.4331,
  y2: 16.5793,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint750_linear_1316:35",
  x1: 15.4955,
  y1: 17.7402,
  x2: 16.5664,
  y2: 16.5793,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint751_linear_1316:35",
  x1: 17.7737,
  y1: 17.7402,
  x2: 18.0964,
  y2: 15.6411,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})));

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f82b6c02.svg";
export { ForwardRef as ReactComponent };